import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import React, { Component, useState } from 'react';
import styled from 'styled-components';

const defaultDrawerStyle = {
  transition: 'width 0.4s'
};

const defaultCollapseStyle = {
  transition: 'left 0.4s',
  top: '3rem'
};

const CollapseMenu = styled(Flex)`
  position: absolute;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 1px solid #d8deea;
  top: 30rem;
  background-color: white;
  z-index: 1;
  cursor: pointer;
  opacity: 1;
  &:hover {
    opacity: 0.8;
  }
`;

const DrawerContainer = styled.div`
  position: relative;
  border-right: 1px solid ${getColor('botticelli')};
`;

const openedStyle = {
  width: '25rem',
  opacity: 1,
  ...defaultDrawerStyle
};

const closedStyle = {
  width: '4rem',
  ...defaultDrawerStyle
};

class CollapseButton extends Component {
  render() {
    const { onClick, opened } = this.props;
    return (
      <CollapseMenu
        items='center'
        justify='center'
        onClick={onClick}
        opened={opened}
        data-cy='toggle-grid-chip-filter'
        style={
          !opened
            ? {
                left: `calc(${closedStyle.width} - 1rem`,
                ...defaultCollapseStyle
              }
            : {
                left: `calc(${openedStyle.width} - 1rem`,
                ...defaultCollapseStyle
              }
        }
      >
        <Icon
          name={!opened ? 'ChevronRight' : 'ChevronLeft'}
          color='nepal'
          size='normal'
        />
      </CollapseMenu>
    );
  }
}

const TitleClose = styled(Text)`
  ${({ opened }) =>
    !opened
      ? 'transform: rotate(-90deg); margin-top: 2rem; padding: 1rem;transition: transform 0.2s;'
      : 'padding-left: 1rem;'}
`;

const TitleContainer = styled(Flex)`
  ${({ opened }) =>
    !opened
      ? 'flex-direction: column; padding: 1.25rem;'
      : `padding: 1.25rem; padding-left: 2rem; border-bottom: 1px solid ${getColor(
          'catskillWhite'
        )};`}
`;

const ContentWrapper = styled.div`
  ${({ opened }) =>
    opened
      ? 'transition: opacity 0.1s 0.25s; opacity: 1; visibility: visible;'
      : 'transition: opacity 0.2s; opacity 0; visibility: hidden;'}
`;

const FiltersPanel = props => {
  const [opened, setOpened] = useState(false);
  const toggleOppened = () => setOpened(value => !value);

  const { width, children, title = 'FILTERS' } = props;
  return (
    <>
      <CollapseButton opened={opened} onClick={toggleOppened} width={width} />
      <DrawerContainer
        data-cy='drawer-container'
        style={opened ? { ...openedStyle } : closedStyle}
      >
        <TitleContainer items='center' opened={opened}>
          <Icon name='Filter' color='shuttleGray' />
          <TitleClose opened={opened} size='large'>
            {title}
          </TitleClose>
        </TitleContainer>
        <ContentWrapper opened={opened}>{children}</ContentWrapper>
      </DrawerContainer>
    </>
  );
};

export default FiltersPanel;
